/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, DateRange, Highcharts, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';
  var TimeRangeViewer = mp.marketing.trends.TimeRangeViewer;

  var IPHONE_6 = `iPhone 6`,
    IPHONE_6_PLUS = `iPhone 6 Plus`,
    OTHER_IPHONE = `Other`,
    NOT_AN_IPHONE = `NOT AN IPHONE`,
    SERIES_ORDER = [IPHONE_6, IPHONE_6_PLUS, OTHER_IPHONE];

  var iphone_model_name = function(model_id) {
    if (model_id.match(/^iPhone7,1$/)) { // 7 means 6, yes it's weird
      return IPHONE_6_PLUS;
    } else if (model_id.match(/^iPhone7,2$/)) {
      return IPHONE_6;
    } else if (model_id.match(/^iPhone[0-9]+,\d$/)) {
      return OTHER_IPHONE;
    }
    return NOT_AN_IPHONE;
  };


  ns.IPhone6 = mp.marketing.trends.widgets.TrendReport.extend({
    get_defaults() {
      return {
        date_range: new DateRange(new Date(2014, 8, 1), new Date()),
        report_unit: `month`,
      };
    },

    get_queries() {
      var unit = this.session.get(`report_unit`);
      var date_range = this.session.get(`date_range`);

      return {
        base: {
          'query_name': `ios_device_models`,
          unit,
          'from_date': date_range.from().toString(mp.utility.default_date_format),
          'to_date': date_range.to().toString(mp.utility.default_date_format),
        },
      };
    },

    get_chart_params(query_data) {
      delete query_data.base.Unknown;

      var parse_date = function(date_string) {
        var date = Date.parseExact(date_string, `yyyy-MM-dd HH:mm:ss`) ||
                       Date.parseExact(date_string, `yyyy-MM-dd`);
        // dates from arb are in PST (project time)
        date.setTimezone(`PST`);
        return date;
      };

      var models_to_series = _.groupBy(query_data.base, function(_, model_id) {
        return iphone_model_name(model_id);
      });
      _.each(SERIES_ORDER, function(model) {
        if (!_.has(models_to_series, model)) {
          models_to_series[model] = [];
        }
      });
      delete models_to_series[NOT_AN_IPHONE];

      var models_to_one_series = {};
      var totals = {};
      _.each(models_to_series, function(model_series, model_name) {
        var this_model = {};

        _.each(model_series, function(series) {
          _.each(series, function(value, date) {
            if (parse_date(date).getTime() < mp.report.globals.utc_now) {
              if (! this_model[date]) {
                this_model[date] = 0;
              }
              if (! totals[date]) {
                totals[date] = 0;
              }
              this_model[date] += value;
              totals[date] += value;
            }
          });
        });
        models_to_one_series[model_name] = this_model;
      });

      var chart_data = _.chain(models_to_one_series)
        .pairs()
        .sortBy(function(model_series_pair) {
          return SERIES_ORDER.indexOf(model_series_pair[0]);
        }, this)
        .map(function(model_series_pair, i) {
          var model = model_series_pair[0],
            series = model_series_pair[1];

          return {
            name: model,
            color: mp.charts.nth_color(i, this.color_scheme),
            data: _.map(series, function(val, date) {
              var unixtime = parse_date(date).getTime();
              var percent = 0;
              if (totals[date]) {
                percent = (val / totals[date]) * 100;
              }
              return [unixtime, percent];
            }).sort(),
            visible: model !== OTHER_IPHONE,
          };
        }, this)
        .value();

      var xaxis_config;
      if (this.session.get(`report_unit`) === `hour`) {
        xaxis_config = {
          'type': `datetime`,
          'tickInterval': 4 * 60 * 60 * 1000, // 4 hrs
          'labels': {
            'formatter'() {
              return Highcharts.dateFormat(`%b. %e, %l %p`, this.value);
            },
            'rotation': -45,
          },
        };
      } else {
        xaxis_config = {
          'type': `datetime`,
          'minTickInterval': 24 * 60 * 60 * 1000, // 24 hrs
          'labels': {
            'formatter'() {
              return Highcharts.dateFormat(`%b. %e`, this.value);
            },
            'rotation': -45,
          },
        };
      }

      return {
        'xAxis': xaxis_config,
        'yAxis': {'labels': {'formatter'() { return this.value + `%`; }}},
        'series': chart_data,
        'tooltip': {
          'shared': true,
          'crosshairs': true,
          'backgroundColor': `rgba(255, 255, 255, 1)`,
          'borderWidth': 1,
          'useHTML': false,
          'pointFormat': `<span style="color:{series.color}">{series.name}</span>: <b>{point.y}%</b><br/>`,
          'valueDecimals': 2,
        },
        'chart': {'marginBottom': 75, 'height': 450},
      };
    },

    _update_multi_selector(chart_data) {
      mp.marketing.trends.widgets.TrendReport.prototype._update_multi_selector.call(this, chart_data);

      // Increase width of IPHONE_6_PLUS multi-selector item to fit full label
      var dropdown = this.multi_selector.dropdowns[SERIES_ORDER.indexOf(IPHONE_6_PLUS)];
      dropdown.container.css(`width`, 160)
        .find(`.title`).css(`width`, 80);
    },

    getDownloadName() {
      return ns.IPhone6.nice_name;
    },
  });

  ns.IPhone6.slug = `iphone_6`;
  ns.IPhone6.nice_name = `iPhone 6 adoption`;
  ns.IPhone6.description = `How quickly will people put their new iPhone 6's to use?`;
  ns.IPhone6.chart_type = `line`;
  ns.IPhone6.color_scheme = `colorblind`;
  ns.IPhone6.asterisk = `Time/Date in UTC`;
  ns.IPhone6.view_class = TimeRangeViewer;
  ns.IPhone6.time_units = [`day`, `week`, `month`];
});

}.call(window));